// Gold at full saturation, HSL 45° 100% 76%: 8:1 against gray-700, and not the washed-out beige a white mix gives.
export const GOLDEN_SOURCE_BACKGROUND = "#FFE085";
